import "./styles.css";
import GameScreen from "./GameScreen/GameScreen";
import ViewStateChange from "./ViewStateChange/ViewStateChange";
import React, { useState } from "react";
import ScoreTable from "./ScoreTable/ScoreTable";
export default function App() {
  const [viewState, viewStateChanger] = useState("game");
  if (viewState === "game") {
    return (
      <>
        <h1 className="guess-color-text">Guess the color</h1>
        <ViewStateChange view={viewState} viewStateChanger={viewStateChanger} />
        <GameScreen />
      </>
    );
  }
  return (
    <>
      <h1 className="guess-color-text">Guess the color</h1>
      <ViewStateChange view={viewState} viewStateChanger={viewStateChanger} />
      <ScoreTable />
    </>
  );
}
